// Modified from https://dev.to/bdtomlin/using-vue-js-as-an-alternative-to-stimulus-js-1ic0

import { setupVueApp, setupVueSSRApp } from "plugins/vue/setup-async"
import { whenI18nReady } from "plugins/i18n-js/state"

import { resolveVueModule } from "vue_module_resolver"

const QUERY_SELECTOR = "[data-vue-component-logical-path]"
const ACTIVE_ATTRIBUTE = "data-vueified"

let init_run = false

export async function init() {
  if (init_run) return
  init_run = true

  // Otherwise locale might not be assigned in HTML yet
  await whenI18nReady()

  for (const el of document.querySelectorAll(QUERY_SELECTOR)) {
    await createVueComponent(el)
  }
  initMutationObserver()
}

function initMutationObserver() {
  const observer = new MutationObserver(callback)
  observer.observe(document.documentElement, { childList: true, subtree: true })
}

async function callback(mutationList: MutationRecord[], _observer: MutationObserver) {
  for (const mutation of mutationList) {
    // order matters! remove those old nodes before adding the new!
    processRemovedNodes(mutation.removedNodes)
    await processAddedNodes(mutation.addedNodes)
  }
}

async function processAddedNodes(nodes: NodeList) {
  for (const node of nodes) {
    if (node.nodeType !== Node.ELEMENT_NODE) continue
    const node_el = node as HTMLElement

    if (node_el.matches(QUERY_SELECTOR)) {
      await createVueComponent(node_el)
    }
    for (const el of node_el.querySelectorAll(QUERY_SELECTOR)) {
      await createVueComponent(el)
    }
  }
}

async function createVueComponent(node: Element) {
  if (node.nodeType !== Node.ELEMENT_NODE) return

  const el = node as HTMLElement
  if (el.dataset?.vueData == null) return
  if (el.dataset?.vueComponentLogicalPath == null) return

  if (node.hasAttribute(ACTIVE_ATTRIBUTE)) return
  node.setAttribute(ACTIVE_ATTRIBUTE, "")

  const vueComponentData = JSON.parse(el.dataset.vueData)
  const setupFunc = el.childNodes.length > 0 ? setupVueSSRApp : setupVueApp
  ;(await setupFunc(await resolveVueModule(el.dataset.vueComponentLogicalPath), vueComponentData)).mount(node)
}

function processRemovedNodes(nodes: NodeList) {
  for (const node of nodes) {
    if (node.nodeType !== Node.ELEMENT_NODE) continue
    const node_el = node as Element

    if (node_el.matches(QUERY_SELECTOR)) {
      destroyVueComponent(node_el)
    }
    for (const el of node_el.querySelectorAll(QUERY_SELECTOR)) {
      destroyVueComponent(el)
    }
  }
}

declare global {
  interface Element {
    // Vue 3
    __vue__?: {
      // https://vuejs.org/api/application.html#app-unmount
      unmount: () => void
    }
  }
}

function destroyVueComponent(node: Element) {
  if (node.__vue__) node.__vue__.unmount()
}
